"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);





// "Mark as unread" from an inbox row. The row turns unread at once; when the
// server rejects the mark or never answers, it turns back (the reducer) and
// the inbox's usual notice for a failed row action says so.
 const useMarkUnread = ({ showWarningBar }) => _react.useCallback.call(void 0, 
  async (blobjectKey) => {
    const marked = await _actions2.default.markBlobjectUnread(blobjectKey).then(() => true).catch(() => false)
    if (!marked) showWarningBar('Failed to mark conversation as unread')
    return marked
  },
  [showWarningBar],
); exports.useMarkUnread = useMarkUnread
